export type JSONSchemaTypes = 'string' | 'integer' | 'boolean' | 'object' | 'array';

export class PrimitiveValue {
    visible?: boolean = true;
    constructor(
        public name: string = '',
        public type: 'string' | 'boolean' | 'integer' | 'date',
        public defaultValue?: string | boolean | number | null,
        public required: boolean = true,
    ) {}
}

export class ArrayValue {
    visible?: boolean = true;
    collapsed?: boolean = false;
    children: Array<UIConfigUnit> = [];
    type = 'array' as const;

    constructor(
        public name: string,
        public defaultValue: string | null,
        public required: boolean = false,
    ) {
        this.addChild(new ObjectValue('', true));
    }

    addChild(value: UIConfigUnit) {
        this.children = [value];
        this.children.forEach((child) => (child.visible = true));
        return true;
    }

    collapse() {
        this.children.forEach((child) => {
            child.visible = false;
            if (child instanceof ArrayValue || child instanceof ObjectValue) {
                if (!child.collapsed) child.collapse();
            }
        });
    }

    expand() {
        this.children.forEach((child) => {
            child.visible = true;
            if (child instanceof ArrayValue || child instanceof ObjectValue) {
                if (!child.collapsed) child.expand();
            }
        });
    }

    toggleCollapse() {
        if (this.collapsed) {
            this.collapsed = false;
            this.expand();
        } else {
            this.collapsed = true;
            this.collapse();
        }
    }
}

export class ObjectValue {
    visible?: boolean = true;
    collapsed?: boolean = false;
    children: Array<UIConfigUnit> = [];
    type = 'object' as const;

    constructor(
        public name: string,
        public required: boolean = true,
    ) {}

    addChild(value: UIConfigUnit): boolean {
        let existingValueIndex = this.children.findIndex((child) => child.name === value.name);
        if (existingValueIndex !== -1) {
            return false;
        }
        this.children.push(value);
        this.children.forEach((child) => (child.visible = true));
        return true;
    }

    collapse() {
        this.children.forEach((child) => {
            child.visible = false;
            if (child instanceof ArrayValue || child instanceof ObjectValue) {
                if (!child.collapsed) child.collapse();
            }
        });
    }

    expand() {
        this.children.forEach((child) => {
            child.visible = true;
            if (child instanceof ArrayValue || child instanceof ObjectValue) {
                if (!child.collapsed) child.expand();
            }
        });
    }

    toggleCollapse() {
        if (this.collapsed) {
            this.collapsed = false;
            this.expand();
        } else {
            this.collapsed = true;
            this.collapse();
        }
    }
}

export type UIConfigUnit = PrimitiveValue | ArrayValue | ObjectValue;

export class UIConfig {
    type = 'object' as const;
    children: Array<UIConfigUnit> = [];

    addChild(value: UIConfigUnit): boolean {
        let existingValueIndex = this.children.findIndex((child) => child.name === value.name);
        if (existingValueIndex !== -1) {
            return false;
        }
        this.children.push(value);
        return true;
    }
}
